export class BrowserInfo {
    public name = "";
    public version = "";
    public isChrome = false;
    public isFireFox = false;
    public isSafari = false;
    public isIE = false;
    public isEdge = false;
    public isPhantom = false;

    private _ua: string;

    constructor() {
        this._ua = window.navigator.userAgent;
        if (/edg([ea]|ios)/i.test(this._ua)) {
            this.isEdge = true;
            this.name = "Edge";
            this.version = this._getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i);
        } else if (/chrome|crios|crmo/i.test(this._ua)) {
            this.name = "Chrome";
            this.version = this._getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i);
            this.isChrome = true;
        } else if (/firefox|iceweasel|fxios/i.test(this._ua)) {
            this.name = "FireFox";
            this.isFireFox = true;
            this.version = this._getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i);
        } else if (/safari|applewebkit/i.test(this._ua)) {
            this.isSafari = true;
            this.name = "Safari";
            this.version = this._getFirstMatch(/version\/(\d+(\.\d+)?)/i) || "";
        } else if (/msie|trident/i.test(this._ua)) {
            this.isIE = true;
            this.name = "IE";
            this.version = this._getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i);
        }
        if (/phantomjs/i.test(this._ua)) {
            this.isPhantom = true;
            this.name = "PhantomJS";
            this.version = this._getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i);
        }
    }

    private _getFirstMatch(regex: RegExp) {
        let match = this._ua.match(regex);
        return (match && match.length > 1 && match[1]) || "";
    }

    private _getSecondMatch(regex: RegExp) {
        let match = this._ua.match(regex);
        return (match && match.length > 1 && match[2]) || "";
    }

}

export const currentBrowserInfo = (window as any).currentBrowserInfo =  new BrowserInfo();
